
import apiClient from '../helpers/apiClient';
import { authHeader } from '../helpers/authHeader';


export const stockTransferService = {
    stockTransferDetails,
  stockTransferByDate,
  stockTransferSearch,
  submitStockTransfer,
  stockTransferList,
  stockWareHouseDetails,
  stockTransferAction
};

//========= STOCK 
async function  stockTransferList() {
    return apiClient.get(`/stock-transfer/stock-transfer-list`, authHeader());
}
//========= STOCK END


async function  stockTransferByDate(body) {
    return apiClient.put(`/stock-transfer/stock-transfer-by-date`, body, authHeader());
}


async function  stockTransferSearch(searchText) {
    return apiClient.get(`/stock-transfer/stock-transfer-search?search=${searchText}`, authHeader());
}

async function  stockTransferDetails(id) {
    return apiClient.get(`/stock-transfer/stock-transfer-details/${id}`, authHeader());
}

async function  stockWareHouseDetails(warehouseId) {
    return apiClient.get(`/stock-transfer/stock-transfer-warehouse/${warehouseId}`, authHeader());
}


async function  submitStockTransfer(formData) {
    return apiClient.post(`/stock-transfer/submit-stock-transfer`,formData, authHeader());
}


async function  stockTransferAction(formData) {
    return apiClient.put(`/stock-transfer/stock-transfer-action`,formData, authHeader());
}





// ============= STOCK ADJUSTMENT END============



















